import * as React from 'react'

export const RenewalBindIcon: React.SFC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" stroke="#CFD8DD" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 12a9 9 0 0 1 15.5-6.36" />
                <polyline points="21 3 21 9 15 9" />
                <path d="M21 12a9 9 0 0 1-15.5 6.36" />
                <polyline points="3 21 3 15 9 15" />
            </g>
        </svg>
    )
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Renewal/RenewalBindIcon.tsx